module.exports = function (app) {
    app.controller('pages.assistEmployees.idCards', ["$state", "$scope", "contentService","$window","$document","services","$q","employerUtility","$location","$anchorScroll","coremetrics", "sessionData","storage",
            function ($state, $scope,contentService,$window,$document,services,$q,employerUtility,$location,$anchorScroll,coremetrics, sessionData,storage) {
                var buildURL,
                    params={},
                    setCardSrc,errorMessage;
                $scope.status= {
                    getMembers: false
                };
                $scope.card={
                    imageLoaded: false
                };
                $scope.sections={};
                $scope.expandList=false;
                $scope.address={};
                $scope.users=[];
                // Sidebar
                $scope.$parent.sidebar = {
                    breadCrumb: {
                        primary: {
                            title: "ID Cards"
                        }
                    }
                };
                $scope.viewBack=false;

                if($scope.flashes){
                    $scope.flashes.removeFeedback(0);
                }

                contentService.get("EPR_IDCARD_ERROR").then(function(response){
                    errorMessage=response;
                });

                if ($state && $state.params && $state.params.umi) {
                    //to retain the state params on refresh of the page
                    storage.set('thisUmi', $state.params.umi);
                } else if (storage.get("thisUmi")) {
                    $state.params.umi=storage.get("thisUmi")
                }

                services.eprsvc.idcardMembers().fetch($state.params.umi).then(
                    function(success){
                        var idcards = success.data.payload;
                        if(idcards.length>0) {
                            for (var i = 0; i < idcards.length; i++) {
                                if (idcards[i]['cards'].length > 0) {
                                    $scope.users.push(idcards[i]);
                                }
                            }
                        }
                        //$scope.users=success.data.payload;
                        $scope.status.getMembers=true;
                        if($scope.users.length>0){
                            setCardSrc();
                            $scope.address={
                                address1:$scope.users[0].address,
                                address2:$scope.users[0].address2,
                                city: $scope.users[0].city,
                                state: $scope.users[0].state,
                                zip: $scope.users[0].zip
                            };
                            if ($scope.users[0].cards[0] && $scope.users[0].cards[0].brand) {
                                var theUbk = $scope.users[0].cards[0].brand;
                                switch (theUbk) {
                                    case '6010':
                                    case '9013':
                                        $scope.sections.isMn = true;
                                        break;
                                    case '6012':
                                        $scope.sections.isWy = true;
                                        break;
                                    case '6008':
                                    case '6009':
                                        $scope.sections.isIbc = true;
                                        break;
                                    default:
                                        $scope.sections.isWpaEtAl = true;
                                        break;
                                }
                            }
                        }else{
                            // no users with active coverage found
                            $scope.card.imageLoaded=true;
                        }
                    },
                    function(error){
                        $scope.status.getMembers=true;
                        $scope.card.imageLoaded=true;
                        $scope.serviceFailed=true;
                        employerUtility.handleError($scope.flashes,error);
                    }
                );

                setCardSrc=function(){
                    for(var i=0;i<$scope.users.length;i++){
                        for(var j=0;j<$scope.users[i].cards.length;j++){
                            params.MProfileId="";
                            // this works but change to loginId
                            params.UId=$scope.users[i].cards[j].fullUmi;
                            params.GNumber=$scope.users[i].cards[j].groupNumber;
                            params.UNumber=$scope.users[i].cards[j].fullUmi;
                            params.EciId=$scope.users[i].ecid;
                            params.CType=$scope.users[i].cards[j].cType;
                            params.type=$scope.users[i].cards[j].type;
                            params.SID="WEB";
                            // TO DO brand logic
                            params.logoId=$scope.users[i].cards[j].brand;
                            params.covIndId=$scope.users[i].ciid;
                            params.MTMID="viewIdCard";
                            params.timestamp=new Date().getTime();

                            $scope.users[i].name= $scope.users[i].firstName+" "+$scope.users[i].lastName;
                            $scope.users[i].cards[j].src=buildURL('/rbsmbl/x-services/idcard/getidcard',params);
                            //$scope.users[i].cards[j].src="resources/image/prob.jpg";
                            $scope.users[i].cards[j].viewBack=false;
                            $scope.users[i].cards[j].selected="not-selected";
                            $scope.users[i].cards[j].error=false;
                            $scope.users[i].cards[j].imageLoaded=false;
                            $scope.users[i].cards[j].errorMessage=errorMessage;
                            var brand=$scope.users[i].cards[j].brand;
                            if(brand && brand === '6008' || brand === '6009'){
                                //ibc and ameri health
                                $scope.users[i].cards[j].altCardSize='altCardSize';
                            }
                        }
                    }

                    $scope.selectedUser = $scope.users[0];
                    if($scope.selectedUser.cards[0].type==='ServiceProduct' && $scope.selectedUser.cards.length>1){
                        $scope.selectedUser.cardIndex = 1;
                    }else{
                        $scope.selectedUser.cardIndex = 0;
                    }
                    $scope.card = $scope.selectedUser.cards[$scope.selectedUser.cardIndex];
                    $scope.card.selected = "selected";

                }

                contentService.getAll("states").then(
                    function(response){
                        $scope.usaStates=response;
                    }
                );

                buildURL=function(url,params){
                    var queryParams="";
                    var index=0;

                    for(var key in params){
						if (params.hasOwnProperty(key)) {
							var value = params[key] !== undefined
								? params[key]
								: '';

							queryParams = queryParams + key + "=" + value;

							if(index<Object.keys(params).length-1){
								queryParams=queryParams+"&";
							}
							index++;
						}
					}
					return url+"?"+queryParams;
                };

                $scope.viewBackClick=function(){
                    $scope.viewBack=!$scope.viewBack;
                    $scope.card.viewBack=$scope.viewBack;
                };

                $scope.changeSelectedUser=function(selectedUser){
                    $scope.selectedUser=selectedUser;
                    $scope.selectedUser.cardIndex=0;
                    $scope.card=$scope.selectedUser.cards[$scope.selectedUser.cardIndex];
                    $scope.card.selected="selected";
                    $scope.viewBack=false;
                };

                $scope.previous=function(){
                    $scope.card.selected="not-selected";
                    $scope.selectedUser.cardIndex=$scope.selectedUser.cardIndex-1;
                    $scope.card=$scope.selectedUser.cards[$scope.selectedUser.cardIndex];
                    $scope.card.selected="selected";
                    $scope.viewBack=false;
                };

                $scope.next=function(){
                    $scope.card.selected="not-selected";
                    $scope.selectedUser.cardIndex=$scope.selectedUser.cardIndex+1;
                    $scope.card=$scope.selectedUser.cards[$scope.selectedUser.cardIndex];
                    $scope.card.selected="selected";
                    $scope.viewBack=false;
                };

                $scope.goTo=function(index){
                    $scope.card.selected="not-selected";
                    $scope.selectedUser.cardIndex=index;
                    $scope.card=$scope.selectedUser.cards[index];
                    $scope.card.selected="selected";
                    $scope.viewBack=false;
                    $scope.card.viewBack=false;
                };

                $scope.idCardCoremetrics=function(){
                    coremetrics.pageviewTag('EMPLOYERS:ASSIST EMPLOYEES:ID CARDS','EMPLOYERS:ASSIST EMPLOYEES');
                }

                $scope.orderIdCardEventStart = function(){
                    coremetrics.startConversion('EMPLOYERS:ASSIST EMPLOYEES:ORDER ID CARD','EMPLOYERS:ASSIST EMPLOYEES');
                }
                $scope.orderIdCardEventEnd=function(){
                    coremetrics.finishConversion('EMPLOYERS:ASSIST EMPLOYEES:ORDER ID CARD','EMPLOYERS:ASSIST EMPLOYEES');
                }

                $scope.printIdCardEventEnd=function(){
                    coremetrics.finishConversion('EMPLOYERS:ASSIST EMPLOYEES:PRINT ID CARD','EMPLOYERS:ASSIST EMPLOYEES');
                }
                $scope.eventEndReportStolen=function(){
                    coremetrics.finishConversion('EMPLOYERS:ASSIST EMPLOYEES:REPORT ID CARD STOLEN','EMPLOYERS:ASSIST EMPLOYEES');
                }

                $scope.printCard=function(){
                    $scope.printIdCardEventEnd();
                    var win = window.open();
                    win.document.open();
                    win.document.write('<div id="specialPrintDiv" style="width: 100%; margin: 0 auto;"><div style="overflow: hidden; width: 100%; margin: 0 auto; text-align: center;"><img style="width: 90%;" src="'+$scope.card.src+'"></div><div style="position: fixed; bottom: 0; width: 100%;"></div></div>');
                    setTimeout(function() {
                        win.document.close();
						win.focus();
						win.print();
                        win.close();
                    }, 3750);

                };

                $scope.zoomIDCard=function(){
                    var bodyElement=angular.element($document).find("body");
                    var imageElement=angular.element('<div style="width: 100%" class="hide-all-siblings"><div style="overflow: scroll; width: 100%"><img style="width: 300%;" src="'+$scope.card.src+'"></div><div style="position: fixed; bottom: 0; width: 100%;"><button style="width: 98%;" class="display-block secondary-button-1">Close</button></div></div>');
                    var buttonElement=angular.element(imageElement.find('button')[0]);
                    function removeImage(){
                        imageElement.remove();
                    }
                    buttonElement.on('click',removeImage);
                    bodyElement.prepend(imageElement);
                };

                $scope.expandCollapseAllRows=function(){
                    $scope.expandList=!$scope.expandList;
                    for(var i=0;i<$scope.users.length;i++){
                        $scope.users[i].expand=$scope.expandList;
                    }

                };

                $scope.collapseAllRows=function(){
                    $scope.expandList=false;
                    for(var i=0;i<$scope.users.length;i++){
                        $scope.users[i].expand=false;
                    }

                };

                $scope.checkExpand=function(){
                    var allExpanded=true;
                    for(var i=0;i<$scope.users.length;i++){
                        if(!$scope.users[i].expand){
                            allExpanded=false;
                            break;
                        }
                    }
                    $scope.expandList=allExpanded;
                };

                $scope.orderIdCards=function(){
                    if($scope.flashes){
                        $scope.flashes.removeFeedback(0);
                    }
                    if($scope.orderIdCardFlashes){
                        $scope.orderIdCardFlashes.removeFeedback(0);
                    }
                    var uniqueGroups={};
                    for(var i=0;i<$scope.users.length; i++){
                        for(var j=0;j<$scope.users[i].cards.length;j++){
                            var card=$scope.users[i].cards[j];
                            var key=card.groupNumber+"_"+card.lob;
                            if(card.orderIdCard){
                                if(!uniqueGroups[key]){
                                    uniqueGroups[key]={};
                                }
                                if(!uniqueGroups[key][$scope.users[i].ecid]){
                                    uniqueGroups[key][$scope.users[i].ecid]={'individual':true};
                                }
                                uniqueGroups[key][$scope.users[i].ecid][card.type.toLowerCase()]=true;
                            }
                        }
                    }
                    if(Object.keys(uniqueGroups).length===0){
                        employerUtility.showFlashes($scope.orderIdCardFlashes,"warning","EPR_IDCARD_ORDER_SELECT_MEMBER_WARNING");
                        $location.hash('order-id-card-flashes');
                        $anchorScroll();
                        return;
                    }
                    var promises=[];
                    for(var group in uniqueGroups){
                        var request={};
                        request.address1=$scope.address.address1;
                        request.address2=$scope.address.address2;
                        request.city=$scope.address.city;
                        request.state=$scope.address.state;
                        request.zip=$scope.address.zip;
                        request.groupNumber=group.split("_")[0];
                        request.umi=$state.params.umi;
                        var ecids = Object.keys(uniqueGroups[group]);
                        if(ecids.length > 0){
                            request.memberEcid=ecids[0];
                        }
                        request.memberList=[];
                        request.lob=group.split("_")[1];
                        for(var ecid in uniqueGroups[group]){
                            var member=uniqueGroups[group][ecid];
                            member.ecid=ecid;
                            request.memberList.push(member);
                        }
                        promises.push(services.eprsvc.orderIdCard().orderIdCard(request));
                    }

                    $q.all(promises).then(
                        function(response){
                            $scope.idCardCoremetrics();
                            $scope.orderIdCardEventEnd();
                            var ubk = sessionData.employerInfo.brandName;
                            if(ubk == '6012'){

                                employerUtility.showFlashes($scope.flashes, "success", "EPR_IDCARD_ORDER_WYSUCCESS");
                            }
                            else {
                                employerUtility.showFlashes($scope.flashes, "success", "EPR_IDCARD_ORDER_SUCCESS");
                            }
                            $scope.sections.orderIdCard=false
                            $window.scrollTo(0, 0);
                            for(var i=0;i<$scope.users.length; i++){
                                for(var j=0;j<$scope.users[i].cards.length;j++){
                                    $scope.users[i].cards[j].orderIdCard=false;
                                }
                            }
                            $scope.collapseAllRows();
                        },
                        function(error){
                            employerUtility.handleError($scope.orderIdCardFlashes,error);
                            $location.hash('order-id-card-flashes');
                            $anchorScroll();
                        }
                    );

                };
            }
        ]
    );
};
